import { useEffect, useState } from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { IStackProps, Stack, StackItem } from "@fluentui/react/lib/Stack";
import {
  Breadcrumb,
  ComboBox,
  DefaultButton,
  FontSizes,
  FontWeights,
  IBreadcrumbItem,
  Label,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import "../../CustomerAccount/CustomerAccountStyle.css";
import {
  TextFieldStyles,
  SaveAndNextButtonStyleShipping,
  TextGrayFieldStyles,
  EditComboBoxStyles,
  EditContactHeadingStyle,
  MediumTextFieldStyles,
  EditButtonStyle,
  RegisterCountryBoxStyles,
  disbaledComboBoxStyles,
  DisabledMediumTextFieldStyles,
  DisabledRegisterCountryBoxStyles,
} from "../CustomerStyle";
import {
  ICustomerAccountsProps,
  RegisterAddress,
  RequestCustomerEditAccount,
  ResponseCustomerEditAccount,
} from "../Customer.types";
import {
  affilationOptions,
  countryWiseStateList,
  paymentTermsOptions,
  typeAffilationOptions,
} from "../CustomerFormInitialValues";
import { CustomerService } from "../../../services/Customers/CustomerService";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import {
  SeparatorStyles,
  stackTokensWithGap10,
  stackTokensWithGap30,
} from "../../Quotation/QuotationStyle";
import {
  AFFILATION_REQUIRED,
  AUTHORIZED_BUYER_EMAIL_REQUIRED,
  AUTHORIZED_BUYER_PHONE_REQUIRED,
  CITY_REQUIRED,
  COUNTRY_REQUIRED,
  CUSTOMER_CERTIFIED_EMAIL_REQUIRED,
  EMAIL_VALIDATION,
  LEADACCOUNT_ID_REQUIRED,
  NUMBERS_ALLOWED,
  PAYMENT_TERMS_REQUIRED,
  POSTALCODE_REQUIRED,
  PROVINCE_REQUIRED,
  Street_PO_BOX_VALIDATION,
  emailRegex,
  poBoxRegex,
  validateEditCustomerAccountFields,
  validateRegisteredAddressFields,
} from "./EditCustomerValidation";
import { InitialStateOfResponseMessage } from "../../Quotation/Common/QuotationData";
import {
  Card,
  CardFooterBase,
  CardStandardHeader,
  CoherencePanel,
  LoadingState,
} from "@coherence-design-system/controls";
import {
  BreadcrumbStyle,
  GrayText,
  LoadingContainerStyle,
} from "../../Quotation/AddQuotation/AddQuotationStyle";
import { useBoolean } from "@fluentui/react-hooks";
import { IResponseMessage } from "../../Quotation/Quotation.types";
import { STREET_REQUIRED } from "../../CountriesProfile/CountriesProfileValidation";
import {
  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
  INVALID_PHONENUMBER,
  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
  SPECIL_CHARACTER_INVALID_PHONENUMBER,
  allowSpecialCharacterExcludingSome,
  numbersOnly,
  phoneNumberRegex,
  contactNumberRegex,
  contactNameCharacterLimit,
  CONTACT_FIRSTNAME_CHARACTER_LIMIT,
  CONTACT_LASTNAME_CHARACTER_LIMIT,
  emailCharacterLimit,
  EMAIL_CHARACTER_LIMIT,
  postalCodeCharacterLimit,
  POSTALCODE_CHARACTER_LIMIT,
  cityCharacterLimit,
  CITY_CHARACTER_LIMIT,
} from "../AddNewCustomerAccount/AddCustomerValidation";
import { useLocalStorageContext } from "../../../Provider/LocalStorageProvider";
import { UserRoles } from "../../../common/enum/UserRoles";
import { CommonService } from "../../../services/Common/CommonService";
import { businessEducationAffiliation } from "../CustomerFormInitialValues";

const intialResponseEditCustomer: ResponseCustomerEditAccount = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  sapAccountId: "",
  sapCustomerAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  addresses: [],
  country: "",
  customerRegion: "",
  paymentTerms: "",
  partitionKey: "",
  eTag: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

const intialResponseValidationEditCustomer: ResponseCustomerEditAccount = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  sapAccountId: "",
  sapCustomerAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  addresses: [],
  country: "",
  customerRegion: "",
  paymentTerms: "",
  partitionKey: "",
  eTag: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

const authorizedBuyerIntialState = {
  contactTitle: "",
  contactFirstName: "",
  contactLastName: "",
  contactPhone: "",
  contactEmail: "",
};

const registeredAddressIntialState = {
  registerStreet: "",
  registerPostal: "",
  registerCity: "",
  registerState: "",
  registerCountry: "",
  registerSapAccountId: "",
  registerCustomerCertifiedEmail: "",
  registerCustomerConsigneeCode: "",
  registerTaxId: ""
};

const countryIntialValue = [
  {
    key: "",
    text: "",
    region: "",
  },
];

export const validateMsxOppertunityIdCheck = (
  value: string | undefined,
  setMsxIdError: (customerError: any) => void,
  setMsxIdExist: (isMsdExist: any) => void
) => {
  setMsxIdExist(false);
  CustomerService.validateMsxOpportunityId(value!)
    .then((res) => {
      if (res?.data?.code === 200 && res?.data?.data) {
        setMsxIdError("");
        setMsxIdExist(true);
      } else {
        setMsxIdError("MSX Account ID is invalid");
        setMsxIdExist(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setMsxIdError("MSX Account ID is invalid");
    });
};

export const validateCustomerTaxIdCheck = (
  value: string | undefined,
  setTaxIdError: (customerAccountError: any) => void,
  setTaxIdExist: (isTaxIdExist: any) => void
) => {
  CustomerService.validateCustomerTaxId(value!)
    .then((res) => {
      if (res?.data?.code === 200 && res?.data?.data) {
        setTaxIdError("Tax ID already exist");
        setTaxIdExist(true);
      } else {
        setTaxIdError("");
        setTaxIdExist(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setTaxIdError("Tax ID is invalid");
    });
};

export const CustomerEditContact: React.FunctionComponent<
  ICustomerAccountsProps
> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { genericRole, userRole, userRegions } = useLocalStorageContext();
  const myparam = location && (location?.state as RequestCustomerEditAccount);
  const appInsights = useAppInsightsContext();
  const [responseEditCustomer, setEditCustomer] = useState(
    intialResponseEditCustomer
  );
  const [isSaveAndExitButtonDisabled, setIsSaveAndExitButtonDisabled] =
    useState(false);
  const [isSaveAndNextButtonDisabled, setIsSaveAndNextButtonDisabled] =
    useState(false);

  const [customerEditAccountError, setEditCustomerAccountError] = useState(
    intialResponseValidationEditCustomer
  );
  const [taxIdExist, setTaxIdExist] = useState(false);
  const [msxIdExist, setMsxIdExist] = useState(true);
  const [msxIdError, setMsxIdError] = useState("");
  const [taxIdError, setTaxIdError] = useState("");
  const [
    isAuthorizedBuyer,
    {
      setTrue: openNewContactAuthorizedBuy,
      setFalse: dismissNewContactAuthorizedPanel,
    },
  ] = useBoolean(false);

  const [
    isRegisteredBuyer,
    {
      setTrue: openNewRegisteredAddressBuy,
      setFalse: dismissNewRegisteredAddressPanel,
    },
  ] = useBoolean(false);

  const columnProps: Partial<IStackProps> = {
    tokens: { childrenGap: 5 },
    styles: { root: { width: 300, height: 150, marginRight: 10 } },
  };

  const [showModalButton, setShowModalButton] = useState(false);

  const [showAuthorizedPanel, setShowAuthorizedPanel] = useState(false);

  const [showRegisteredPanel, setShowRegisterededPanel] = useState(false);

  const [authorizedSuccessMessage, setAuthorizedSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [authorizedFailureMessage, setAuthorizedFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);

  const [registsredSuccessMessage, setRegisteredSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [registsredFailureMessage, setRegisteredFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);

  const [contactAuthorizedBuyer, setContactAuthorizedBuyer] = useState(
    authorizedBuyerIntialState
  );

  const [registeredBuyer, setRegisteredBuyer] = useState(
    registeredAddressIntialState
  );

  const [customerSuccessMessage, setCustomerSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [customerFailureMessage, setCustomerFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [isPageReload, setIsPageReload] = useState(false);
  const [countryOptions, setCountryOptions] = useState(countryIntialValue);
  const customerEditAccountComboBoxStyle = {
    root: { width: 250 },
    callout: { width: "300px", height: "290px" },
  };

  const width33 = { width: '33%', marginBottom: '20px' }

  let registeredAddress = responseEditCustomer?.addresses?.find(
    (x) => x.affilation === "Registered Address"
  );

  const streetLength = registeredAddress?.street?.length || 20;
  const registerAddressPixel = "260px";

  let primaryBillingAddress =
    responseEditCustomer?.addresses.map((x) => x.affilation === "Billing")
      .length > 0
      ? responseEditCustomer?.addresses.find(
        (x) =>
          x.affilation === "Billing" &&
          x.isAddressPrimary?.toLocaleLowerCase() === "yes"
      )
      : responseEditCustomer?.addresses.find((x) => x.affilation === "Billing");

  const billingAddressStreetLength =
    primaryBillingAddress?.street?.length || 20;
  const billingAddressPixel =
    billingAddressStreetLength > 20 ? "540px" : "470px";

  let primaryShippingAddress =
    responseEditCustomer?.addresses.map((x) => x.affilation === "Shipping")
      .length > 0
      ? responseEditCustomer?.addresses.find(
        (x) =>
          x.affilation === "Shipping" &&
          x.isAddressPrimary?.toLocaleLowerCase() === "yes"
      )
      : responseEditCustomer?.addresses.find(
        (x) => x.affilation === "Shipping"
      );

  const shippingAddressStreetLength =
    primaryShippingAddress?.street?.length || 20;
  const shippingAddressPixel =
    shippingAddressStreetLength > 20 ? "540px" : "470px";

  const registerAddressPanelStateList = countryWiseStateList.filter(
    (x) =>
      x.country.toLocaleLowerCase() ===
      registeredAddress?.country?.toLocaleLowerCase()
  );
  const [
    registeredAddressPanelStateOptions,
    setRegisteredAddressPanelStateOptions,
  ] = useState(registerAddressPanelStateList);

  const [loader, setLoader] = useState({ isLoading: false, message: "" });

  const [isLoading, setIsLoading] = useState(false);

  const [editRegisterAddressError, setEditRegisterAddressError] =
    useState<RegisterAddress>(registeredAddressIntialState);
  const REGISTERED_ADDRESS_KEY = affilationOptions.find(option => option.text === "Registered Address")?.key;
  const useScreenScale = () => {
    const [screenScale, setScreenScale] = useState(window.devicePixelRatio);

    useEffect(() => {
      const handleResize = () => {
        setScreenScale(window.devicePixelRatio);
      };
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return screenScale;
  };

  function createErrorList(errorObject: any) {
    const errorList = [];
    for (const key in errorObject) {
      if (errorObject.hasOwnProperty(key)) {
        const subErrors = errorObject[key];
        if (typeof subErrors === "object") {
          const nestedErrors: any = createErrorList(subErrors);
          errorList.push(
            ...nestedErrors.map((error: any) => `${key}.${error}`)
          );
        }
        else {
          errorList.push(`${key}: ${errorObject[key]}`);
        }
      }
    }
    return errorList;
  }

  const editAddressErrorList = createErrorList(editRegisterAddressError);

  const editAddressErrorMessage = Object.entries(editAddressErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);

  const editAddressPanelHeight =
    editAddressErrorMessage.length > 3
      ? { height: "700px" }
      : { height: "580px" };
  const screenScale = useScreenScale();

  let cardSize = {
    width: "800px",
    paddingLeft: "20px",
    paddingTop: "10px",
  };

  useEffect(() => {
    setIsLoading(true);
    setShowModalButton(false);
    setAuthorizedFailureMessage(InitialStateOfResponseMessage);
    setRegisteredFailureMessage(InitialStateOfResponseMessage);
    setContactAuthorizedBuyer(authorizedBuyerIntialState);
    setRegisteredBuyer(registeredAddressIntialState);
    props.onCustomerAccount(true);
    if (myparam?.id?.length > 0) {
      CustomerService.getCustomerAccountsInfoById(myparam?.id)
        .then((res) => {
          if (res !== undefined) {
            setEditCustomer(res.data.data.data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(
            "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
            error
          );
        });
      CommonService.populateCountriesDetails()
        .then((res) => {
          if (res !== undefined) {
            setCountryOptions(res.data.data);
          }
        })
        .catch((error) => {
          console.log(
            "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
            error
          );
        });
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setShowModalButton(false);
    setAuthorizedFailureMessage(InitialStateOfResponseMessage);
    setRegisteredFailureMessage(InitialStateOfResponseMessage);
    setContactAuthorizedBuyer(authorizedBuyerIntialState);
    setRegisteredBuyer(registeredAddressIntialState);
    props.onCustomerAccount(true);
    if (myparam?.id.length > 0) {
      CustomerService.getCustomerAccountsInfoById(myparam?.id)
        .then((res) => {
          if (res !== undefined) {
            setEditCustomer(res.data.data.data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(
            "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
            error
          );
        });
    }
  }, [isPageReload]);

  useEffect(() => {
    const registeredAddress = responseEditCustomer?.addresses?.find(
      (address) => address.affilation === REGISTERED_ADDRESS_KEY
    );
    if (registeredAddress?.registeredtaxId !== undefined &&
      registeredAddress?.registeredtaxId !== responseEditCustomer?.taxId) {
      setEditCustomer((prevState) => ({
        ...prevState,
        taxId: registeredAddress.registeredtaxId || "",
      }));
    }
  }, [responseEditCustomer?.addresses]);

  const updateCustomerAccountData = async (
    editCustomer: RequestCustomerEditAccount,
    isSubmitClick: boolean,
    isAuthorizedBuyerEditFlowClick: boolean,
    isRegisteredAddressEditFlowClick: boolean,
    setLoader: (loader: { isLoading: boolean; message: string }) => void
  ) => {
    setShowModalButton(true);
    setAuthorizedSuccessMessage({
      showMessage: false,
      message: ` `,
    });
    setRegisteredSuccessMessage({
      showMessage: false,
      message: ` `,
    });
    setAuthorizedFailureMessage({
      showMessage: false,
      message: ` `,
    });
    setRegisteredFailureMessage({
      showMessage: false,
      message: ` `,
    });
    setCustomerSuccessMessage({
      showMessage: false,
      message: ` `,
    });
    setCustomerFailureMessage({
      showMessage: false,
      message: ` `,
    });
    await CustomerService.updateCustomerAccount(
      editCustomer as RequestCustomerEditAccount
    )
      .then((res) => {
        if (res !== undefined) {
          if (res.data.code !== 400) {
            console.log("Response Data", res.data.data);
            if (
              isAuthorizedBuyerEditFlowClick ||
              isRegisteredAddressEditFlowClick
            ) {
              setIsSaveAndExitButtonDisabled(false);
              if (isAuthorizedBuyerEditFlowClick) {
                setAuthorizedSuccessMessage({
                  showMessage: true,
                  message: "Contact/ Authorized Buyer details update",
                });
              }
              if (isRegisteredAddressEditFlowClick) {
                setRegisteredSuccessMessage({
                  showMessage: true,
                  message: "Business/Sold To Address details update",
                });
              }
              setTimeout(() => {
                setEditCustomer(res.data.data);
                dismissNewContactAuthorizedPanel();
                dismissNewRegisteredAddressPanel();
                setAuthorizedSuccessMessage(InitialStateOfResponseMessage);
                setRegisteredSuccessMessage(InitialStateOfResponseMessage);
                setShowModalButton(false);
                setIsPageReload(!isPageReload);
                setLoader({
                  isLoading: false,
                  message: "",
                });
              }, 3000);
            } else {
              setTimeout(() => {
                userRole === UserRoles.GTFS
                  ? navigate("/Customer", { state: { isSubmitClick: true } })
                  : navigate("/CustomerDiscountSetup", {
                    state: {
                      editCustomer: responseEditCustomer,
                      isEditFlow: true,
                    },
                  });
                setLoader({
                  isLoading: false,
                  message: "",
                });
              }, 1000);
            }
          } else {
            const dataMessage = res?.data?.message;
            setLoader({
              isLoading: false,
              message: "",
            });
            if (isAuthorizedBuyerEditFlowClick) {
              setAuthorizedFailureMessage({
                showMessage: true,
                message: dataMessage?.split("\n").join(", "),
              });
              setShowModalButton(false);
            }
            if (isRegisteredAddressEditFlowClick) {
              setRegisteredFailureMessage({
                showMessage: true,
                message: dataMessage?.split("\n").join(", "),
              });
              if (res?.data?.message.includes("Tax Id")) {
                setTaxIdError("Tax ID already exist");
                setTaxIdExist(true);
              }
              setShowModalButton(false);
            }
            setIsSaveAndExitButtonDisabled(false);
            if (
              isAuthorizedBuyerEditFlowClick ||
              isRegisteredAddressEditFlowClick
            ) {
              setIsSaveAndNextButtonDisabled(false);
            } else {
              setCustomerFailureMessage({
                showMessage: true,
                message: dataMessage?.split("\n").join(", "),
              });
              setIsSaveAndExitButtonDisabled(false);
            }
          }
        }
      })
      .catch((error) => {
        setLoader({
          isLoading: false,
          message: "",
        });
        setIsSaveAndExitButtonDisabled(false);
        appInsights.trackException({
          error: new Error(error as string),
          properties: {
            name: "Error in UpdateCustomerInfo API in CustomerEditContact.tsx",
          },
        });
        console.log(
          "Error in UpdateCustomerInfo API in CustomerEditContact.tsx" + error
        );
        if (isAuthorizedBuyerEditFlowClick) {
          setAuthorizedFailureMessage({
            showMessage: true,
            message: "Contact/ Authorized Buyer details update failed",
          });
        }
        if (isRegisteredAddressEditFlowClick) {
          setRegisteredFailureMessage({
            showMessage: true,
            message: "Business/Sold To Address details update failed",
          });
        }
      });
  };

  const getBreadcrumbItems = () => {
    const items: IBreadcrumbItem[] = [
      {
        text: "Customers",
        key: "Customers",
        onClick: () => {
          navigate("/Customer");
        },
      },
      { text: `Edit Account`, key: `Edit Account` },
    ];
    if (myparam?.name) {
      items.push({
        text: myparam?.name,
        key: myparam?.name,
        isCurrentItem: true,
      });
    }
    return items;
  };

  const _OnClickNextAction = () => {
    setLoader({
      isLoading: true,
      message: "Loading...",
    });
    setEditCustomerAccountError(customerEditAccountError);
    const { isValidated, editCustomerAccountErrors } =
      validateEditCustomerAccountFields(responseEditCustomer);
    if (isValidated && msxIdExist && !taxIdExist) {
      setIsSaveAndExitButtonDisabled(true);
      if (businessEducationAffiliation.text === responseEditCustomer.discount.afilliationSelected && !responseEditCustomer.discount.customerGroup.couponCode.includes(businessEducationAffiliation.key)) {
        responseEditCustomer.discount.customerGroup.couponCode.push(businessEducationAffiliation.key);
      }
      else if (businessEducationAffiliation.text != responseEditCustomer.discount.afilliationSelected) {
        responseEditCustomer.discount.customerGroup.couponCode = responseEditCustomer.discount.customerGroup.couponCode.filter(code => code != businessEducationAffiliation.key)
      }
      updateCustomerAccountData(
        responseEditCustomer as RequestCustomerEditAccount,
        true,
        false,
        false,
        setLoader
      );
    } else {
      setEditCustomerAccountError({
        ...editCustomerAccountErrors,
      });
      setLoader({
        isLoading: false,
        message: "",
      });
    }
  };

  const regionWiseCountry =
    countryOptions &&
    countryOptions
      ?.filter((country) => userRegions.includes(country.region))
      .sort((a, b) => a.text.localeCompare(b.text));

  const onRenderAuthorizedBuyerFooter = () => {
    return (
      <Stack
        verticalFill
        verticalAlign="center"
        style={{ width: "100%", padding: 0 }}
      >
        <Separator styles={SeparatorStyles} />
        <Stack
          horizontal
          style={{ marginTop: "10px" }}
          tokens={{ childrenGap: 10 }}
        >
          <PrimaryButton
            text="Update"
            type="button"
            onClick={handleAuthroizedBuyerUpdate}
            style={EditButtonStyle}
            disabled={showModalButton}
          />
          <DefaultButton
            text="Cancel"
            type="button"
            onClick={() => {
              setShowAuthorizedPanel(false);
              dismissNewContactAuthorizedPanel();
              setAuthorizedFailureMessage(InitialStateOfResponseMessage);
            }}
            style={EditButtonStyle}
            disabled={showModalButton}
          />
        </Stack>
      </Stack>
    );
  };

  const onRenderRegisteredAddressFooter = () => {
    return (
      <Stack
        verticalFill
        verticalAlign="center"
        style={{ width: "100%", padding: 0 }}
      >
        <Separator styles={SeparatorStyles} />

        <Stack
          horizontal
          style={{ marginTop: "10px" }}
          tokens={{ childrenGap: 10 }}
        >
          <PrimaryButton
            text="Update"
            type="button"
            onClick={handleRegisteredAddressUpdate}
            style={EditButtonStyle}
            disabled={showModalButton}
          />
          <DefaultButton
            text="Cancel"
            type="button"
            onClick={() => {
              setShowRegisterededPanel(false);
              dismissNewContactAuthorizedPanel();
              setRegisteredFailureMessage(InitialStateOfResponseMessage);
              setTaxIdError("");
              setTaxIdExist(false);
            }}
            style={EditButtonStyle}
            disabled={showModalButton}
          />
        </Stack>
      </Stack>
    );
  };

  const handleAuthroizedBuyerUpdate = () => {
    const validateObject = JSON.parse(
      JSON.stringify(responseEditCustomer)
    ) as RequestCustomerEditAccount;
    validateObject.authorizedBuyerFirstName =
      contactAuthorizedBuyer.contactFirstName;
    validateObject.authorizedBuyerLastName =
      contactAuthorizedBuyer.contactLastName;
    validateObject.authorizedBuyerPhone = contactAuthorizedBuyer.contactPhone;
    validateObject.authorizedEmailId = contactAuthorizedBuyer.contactEmail;
    validateObject.authorizedBuyerTitle = contactAuthorizedBuyer.contactTitle;
    setEditCustomerAccountError(customerEditAccountError);
    const { isValidated, editCustomerAccountErrors } =
      validateEditCustomerAccountFields(validateObject);
    if (isValidated && msxIdExist && !taxIdExist) {
      setIsSaveAndExitButtonDisabled(true);

      updateCustomerAccountData(
        validateObject as RequestCustomerEditAccount,
        false,
        true,
        false,
        setLoader
      );
    } else {
      setEditCustomerAccountError({
        ...editCustomerAccountErrors,
      });
    }
  };

  const handleRegisteredAddressUpdate = () => {
    setEditCustomerAccountError(customerEditAccountError);
    const validateAddressObject = JSON.parse(
      JSON.stringify(responseEditCustomer)
    );
    const updatedAddressResponseEditCustomer =
      responseEditCustomer.addresses.map((address) => {
        if (address.affilation === "Registered Address") {
          return {
            ...address,
            street: registeredBuyer.registerStreet,
            city: registeredBuyer.registerCity,
            state: registeredBuyer.registerState,
            country: registeredBuyer.registerCountry,
            postalCode: registeredBuyer.registerPostal,
            sapAccountId: registeredBuyer.registerSapAccountId,
            customerCertifiedEmail:
              registeredBuyer.registerCustomerCertifiedEmail,
            customerConsigneeCode:
              registeredBuyer.registerCustomerConsigneeCode,
            registeredtaxId: registeredBuyer.registerTaxId
          };
        }
        return address;
      });

    const { isValidated, editRegisteredAddressErrors } =
      validateRegisteredAddressFields(registeredBuyer);
    if (isValidated && msxIdExist && !taxIdExist) {
      setIsSaveAndExitButtonDisabled(true);
      validateAddressObject.addresses = updatedAddressResponseEditCustomer;
      validateAddressObject.country = registeredBuyer.registerCountry;
      validateAddressObject.taxId = registeredBuyer.registerTaxId;
      updateCustomerAccountData(
        validateAddressObject as RequestCustomerEditAccount,
        false,
        false,
        true,
        setLoader
      );
    } else {
      setEditRegisterAddressError({
        ...editRegisteredAddressErrors,
      });
    }
  };

  const getLinksOfAuthorizedBuyerDataGrid = [
    {

      onClick: () => {
        setContactAuthorizedBuyer({
          contactEmail: responseEditCustomer.authorizedEmailId,
          contactFirstName: responseEditCustomer.authorizedBuyerFirstName,
          contactLastName: responseEditCustomer.authorizedBuyerLastName,
          contactPhone: responseEditCustomer.authorizedBuyerPhone,
          contactTitle: responseEditCustomer.authorizedBuyerTitle,
        });
        setEditCustomerAccountError(intialResponseValidationEditCustomer);
        setShowAuthorizedPanel(true);
        openNewContactAuthorizedBuy();
      },
      children: <>Edit Authorized Buyer details</>,
      underline: false,
    },
  ];

  const getLinksOfregisteredDataGrid = [
    {
      onClick: () => {
        setEditRegisterAddressError(registeredAddressIntialState);
        const registerAddressPanelStateList = countryWiseStateList.filter(
          (x) =>
            x.country.toLocaleLowerCase() ===
            registeredAddress?.country?.toLocaleLowerCase()
        );
        setRegisteredAddressPanelStateOptions(registerAddressPanelStateList);
        setRegisteredBuyer({
          registerCity: registeredAddress?.city || "",
          registerCountry: registeredAddress?.country || "",
          registerPostal: registeredAddress?.postalCode || "",
          registerState: registeredAddress?.state || "",
          registerStreet: registeredAddress?.street || "",
          registerSapAccountId: registeredAddress?.sapAccountId || "",
          registerCustomerCertifiedEmail:
            registeredAddress?.customerCertifiedEmail || "",
          registerCustomerConsigneeCode:
            registeredAddress?.customerConsigneeCode || "",
          registerTaxId: registeredAddress?.registeredtaxId || ""
        });
        setShowRegisterededPanel(true);
        openNewRegisteredAddressBuy();
      },
      children: <>Edit Business/Sold To Address details</>,
      underline: false,
    },
  ];

  const getLinksOfBillingAddressesDataGrid = [
    {
      onClick: () => {
        setIsSaveAndExitButtonDisabled(false);
        navigate("/CustomerEditAddress", {
          state: {
            ...responseEditCustomer,
            selectedAddress: "Billing",
          },
        });
      },
      children: <>Edit Billing Address details</>,
      underline: false,
    },
  ];

  const getLinksOfShippingAddressesDataGrid = [
    {
      onClick: () => {
        setIsSaveAndExitButtonDisabled(false);
        navigate("/CustomerEditAddress", {
          state: {
            ...responseEditCustomer,
            selectedAddress: "Shipping",
          },
        });
      },
      children: <>Edit Shipping Address details</>,
      underline: false,
    },
  ];

  if (isLoading || responseEditCustomer === undefined) {
    return <Spinner size={SpinnerSize.large} />;
  }

  return responseEditCustomer ? (
    <Stack
      verticalFill
      verticalAlign="start"
      tokens={stackTokensWithGap10}
      style={{ backgroundColor: "#FAF9F8" }}
    >
      {customerSuccessMessage.showMessage && (
        <MessageBar
          messageBarType={MessageBarType.success}
          onDismiss={() =>
            setCustomerSuccessMessage(InitialStateOfResponseMessage)
          }
        >
          {customerSuccessMessage.message}
        </MessageBar>
      )}
      {customerFailureMessage.showMessage && (
        <MessageBar
          messageBarType={MessageBarType.error}
          onDismiss={() =>
            setCustomerFailureMessage(InitialStateOfResponseMessage)
          }
        >
          {customerFailureMessage.message}
        </MessageBar>
      )}

      {loader?.isLoading ? (
        <div style={LoadingContainerStyle}>
          <LoadingState primaryText={loader.message} styles={{}} />
        </div>
      ) : (
        <>
          <Breadcrumb
            items={getBreadcrumbItems()}
            style={{ marginLeft: "1%", marginBottom: "-5px" }}
            styles={BreadcrumbStyle}
          />
          <Stack horizontal tokens={{ childrenGap: 50 }}>
            <Card>
              <Label
                style={{
                  fontSize: FontSizes.size18,
                  display: "inline",
                  fontWeight: FontWeights.bold,
                }}
              >
                {`Edit Customer Details`}
              </Label>
            </Card>
          </Stack>
          <Stack style={{ overflowY: "auto" }}>
            {responseEditCustomer?.accountId && (
              <Stack horizontal style={cardSize}>
                <Card
                  header={
                    <CardStandardHeader cardTitle="Business Information" />
                  }
                >
                  <Stack style={{ marginRight: "15px" }}>
                    <Stack horizontal horizontalAlign="space-between">
                      <TextField
                        styles={TextGrayFieldStyles}
                        label="Customer Account ID"
                        name="accountId"
                        readOnly
                        value={responseEditCustomer?.accountId}
                      />
                      <TextField
                        styles={TextGrayFieldStyles}
                        label="Customer Name (Legal Entity)"
                        name="customerName"
                        required
                        readOnly
                        value={responseEditCustomer.name}
                      />
                    </Stack>
                    <Stack horizontal horizontalAlign="space-between">
                      <TextField
                        styles={
                          genericRole !== -1
                            ? TextFieldStyles
                            : TextGrayFieldStyles
                        }
                        label="SAP Customer Account ID"
                        name="sapCustomerAccountId"
                        readOnly={genericRole !== -1 ? false : true}
                        value={responseEditCustomer?.sapCustomerAccountId}
                        onChange={(e, sapCustomerAccountIdValue) => {
                          setEditCustomer({
                            ...responseEditCustomer,
                            sapCustomerAccountId: sapCustomerAccountIdValue || "",
                          });
                        }}
                      />
                      <TextField
                        styles={
                          genericRole !== -1
                            ? TextFieldStyles
                            : TextGrayFieldStyles
                        }
                        label="Lead Account ID (MSX)"
                        name="leadAccountId"
                        required
                        readOnly={genericRole !== -1 ? false : true}
                        value={responseEditCustomer?.legalAccountId}
                        onChange={(e, legalAccountIdValue) => {
                          if (
                            legalAccountIdValue &&
                            legalAccountIdValue?.length > 0
                          ) {
                            setEditCustomerAccountError({
                              ...customerEditAccountError,
                              legalAccountId: "",
                            });
                            validateMsxOppertunityIdCheck(
                              legalAccountIdValue,
                              setMsxIdError,
                              setMsxIdExist
                            );
                          } else {
                            setEditCustomerAccountError({
                              ...customerEditAccountError,
                              legalAccountId: LEADACCOUNT_ID_REQUIRED,
                            });
                          }
                          setEditCustomer({
                            ...responseEditCustomer,
                            legalAccountId: legalAccountIdValue ?? "",
                          });
                        }}
                        errorMessage={
                          msxIdError === ""
                            ? customerEditAccountError.legalAccountId
                            : msxIdError
                        }
                      />
                    </Stack>
                    <Stack horizontal horizontalAlign="space-between">
                      <TextField
                        styles={
                          genericRole !== -1
                            ? TextFieldStyles
                            : TextGrayFieldStyles
                        }
                        label="Tax ID (Legal Entity)"
                        name="taxId"
                        readOnly={userRole === UserRoles.GTFS}
                        value={responseEditCustomer?.addresses?.find(
                          (address) => address.affilation === REGISTERED_ADDRESS_KEY
                        )?.registeredtaxId}
                        onChange={(e, registeredtaxIdValue) => {
                          if (registeredtaxIdValue?.toLocaleLowerCase() === "n/a") {
                            registeredtaxIdValue = "N/A";
                            setTaxIdError("");
                            setTaxIdExist(false);
                          }
                          if (
                            registeredtaxIdValue !== undefined &&
                            registeredtaxIdValue !== null &&
                            registeredtaxIdValue !== ""
                          ) {
                            setTaxIdError("");
                            var specialCharacterCompanyTaxId =
                              allowSpecialCharacterExcludingSome.test(
                                registeredtaxIdValue
                              );
                            if (specialCharacterCompanyTaxId) {
                              setEditRegisterAddressError({
                                ...editRegisterAddressError,
                                registerTaxId: "",
                              });
                            } else {
                              setEditRegisterAddressError({
                                ...editRegisterAddressError,
                                registerTaxId:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setTaxIdError("");
                            setEditRegisterAddressError({
                              ...editRegisterAddressError,
                              registerTaxId: "",
                            });
                          }

                          const updatedAddresses = responseEditCustomer?.addresses?.map((address) =>
                            address.affilation === REGISTERED_ADDRESS_KEY
                              ? { ...address, registeredtaxId: registeredtaxIdValue || "" }
                              : address
                          );

                          setEditCustomer((prevState) => ({
                            ...prevState,
                            addresses: updatedAddresses,
                          }));

                          setRegisteredBuyer({
                            ...registeredBuyer,
                            registerTaxId: registeredtaxIdValue || "",
                          });
                        }}
                        errorMessage={
                          taxIdError !== ""
                            ? taxIdError
                            : ""
                        }
                      />
                      <ComboBox
                        styles={
                          genericRole !== -1
                            ? EditComboBoxStyles
                            : disbaledComboBoxStyles
                        }
                        required
                        disabled={genericRole !== -1 ? false : true}
                        label="Payment Terms"
                        autoComplete="on"
                        options={paymentTermsOptions}
                        selectedKey={responseEditCustomer?.paymentTerms}
                        onChange={(e, paymentTermsValue) => {
                          if (
                            paymentTermsValue &&
                            paymentTermsValue?.text?.length > 0
                          ) {
                            setEditCustomerAccountError({
                              ...customerEditAccountError,
                              paymentTerms: "",
                            });
                          } else {
                            setEditCustomerAccountError({
                              ...customerEditAccountError,
                              paymentTerms: PAYMENT_TERMS_REQUIRED,
                            });
                          }
                          setEditCustomer({
                            ...responseEditCustomer,
                            paymentTerms:
                              paymentTermsValue?.key.toString() || "",
                          });
                        }}
                        allowFreeInput
                        errorMessage={customerEditAccountError.paymentTerms}
                      />
                    </Stack>
                    <Stack horizontal horizontalAlign="space-between">
                      <ComboBox
                        styles={
                          genericRole !== -1
                            ? EditComboBoxStyles
                            : disbaledComboBoxStyles
                        }
                        label="Type/Affiliation"
                        required
                        disabled={genericRole !== -1 ? false : true}
                        autoComplete="on"
                        options={typeAffilationOptions}
                        selectedKey={responseEditCustomer?.affilation}
                        onChange={(e, affilationValue) => {
                          if (
                            affilationValue &&
                            affilationValue?.text.length > 0
                          ) {
                            setEditCustomerAccountError({
                              ...customerEditAccountError,
                              affilation: "",
                            });
                          } else {
                            setEditCustomerAccountError({
                              ...customerEditAccountError,
                              affilation: AFFILATION_REQUIRED,
                            });
                          }
                          const employeePricingSelected =
                            affilationValue?.text.toString() ===
                            "Business Government";

                          if (employeePricingSelected) {
                            setEditCustomer({
                              ...responseEditCustomer,
                              affilation:
                                affilationValue?.text.toString() ?? "",
                              discount: {
                                ...responseEditCustomer.discount,
                                afilliationSelected:
                                  affilationValue?.text.toString() ?? "",
                              },
                            });
                          } else {
                            setEditCustomer({
                              ...responseEditCustomer,
                              affilation:
                                affilationValue?.text.toString() ?? "",
                              discount: {
                                ...responseEditCustomer.discount,
                                afilliationSelected:
                                  affilationValue?.text.toString() ?? "",
                                customerGroup: {
                                  ...responseEditCustomer.discount
                                    .customerGroup,
                                  governmentDiscountSelected: false,
                                },
                              },
                            });
                          }
                        }}
                        allowFreeInput
                        errorMessage={customerEditAccountError.affilation}
                      />
                    </Stack>
                  </Stack>
                </Card>
              </Stack>
            )}
            {responseEditCustomer.accountId && (
              <Stack horizontal style={cardSize}>
                <Card
                  styles={{
                    layout: { height: "170px" },
                    footer: { padding: "0" },
                  }}
                  header={
                    <CardStandardHeader cardTitle="Contact/Authorized Buyer" />
                  }
                  footer={
                    <Stack style={{ position: "relative" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "1px",
                          backgroundColor: "rgb(225, 223, 221)",
                          marginBottom: "10px",
                        }}
                      ></div>
                      {genericRole !== -1 && userRole !== UserRoles.GTFS && (
                        <CardFooterBase
                          styles={{ root: { marginLeft: "12px" } }}
                          links={getLinksOfAuthorizedBuyerDataGrid}
                        />
                      )}
                    </Stack>
                  }
                >
                  <Stack verticalAlign="space-evenly">
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>First Name</h4>
                        {responseEditCustomer.authorizedBuyerFirstName && (
                          <StackItem>
                            <p
                              style={GrayText}
                            >{`${responseEditCustomer?.authorizedBuyerFirstName}`}</p>
                          </StackItem>
                        )}
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Last Name</h4>
                        {responseEditCustomer.authorizedBuyerLastName && (
                          <StackItem>
                            <p
                              style={GrayText}
                            >{`${responseEditCustomer?.authorizedBuyerLastName}`}</p>
                          </StackItem>
                        )}
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Job Title</h4>
                        {responseEditCustomer.authorizedBuyerTitle && (
                          <StackItem>
                            <p
                              style={GrayText}
                            >{`${responseEditCustomer?.authorizedBuyerTitle}`}</p>
                          </StackItem>
                        )}
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Phone</h4>
                        {responseEditCustomer.authorizedBuyerPhone && (
                          <StackItem>
                            <p
                              style={GrayText}
                            >{`${responseEditCustomer?.authorizedBuyerPhone}`}</p>
                          </StackItem>
                        )}
                      </Stack>
                      <Stack style={{ ...width33, wordWrap: 'break-word' }}>
                        <h4 style={EditContactHeadingStyle}>Email</h4>
                        {responseEditCustomer.authorizedEmailId && (
                          <StackItem>
                            <p
                              style={GrayText}
                            >{`${responseEditCustomer?.authorizedEmailId}`}</p>
                          </StackItem>
                        )}
                      </Stack>
                    </Stack>
                  </Stack>
                </Card>
              </Stack>
            )}
            {responseEditCustomer.accountId && (
              <Stack horizontal style={cardSize}>
                <Card
                  styles={{
                    layout: { height: registerAddressPixel },
                    footer: { padding: "0" },
                  }}
                  header={
                    <CardStandardHeader cardTitle="Business/Sold To Address (Legal Entity)" />
                  }
                  footer={
                    <Stack style={{ position: "relative" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "1px",
                          backgroundColor: "rgb(225, 223, 221)",
                          marginBottom: "10px",
                        }}
                      ></div>
                      {(genericRole !== -1 || userRole === UserRoles.GTFS) && (
                        <CardFooterBase
                          styles={{ root: { marginLeft: "12px" } }}
                          links={getLinksOfregisteredDataGrid}
                        />
                      )}
                    </Stack>
                  }
                >
                  <Stack
                    verticalAlign="space-evenly"
                    tokens={{ childrenGap: 5 }}
                  >
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Street (Must not be P.O. Box)
                        </h4>
                        <StackItem>
                          <p
                            style={GrayText}
                          >{`${registeredAddress?.street}`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Zip/Postal Code</h4>
                        <StackItem>
                          <p
                            style={GrayText}
                          >{`${registeredAddress?.postalCode}`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>City</h4>
                        <StackItem >
                          <p style={GrayText}>{`${registeredAddress?.city}`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>State/Province</h4>
                        <StackItem>
                          <p
                            style={GrayText}
                          >{`${registeredAddress?.state}`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Sold To SAP Account ID
                        </h4>
                        <StackItem>
                          <p style={GrayText}>{`${registeredAddress?.sapAccountId ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Country</h4>
                        <StackItem>
                          <p
                            style={GrayText}
                          >{`${registeredAddress?.country}`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Customer Certified Email
                        </h4>
                        <StackItem>
                          <p
                            style={GrayText}
                          >{`${registeredAddress?.customerCertifiedEmail}`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Customer Consignee Code
                        </h4>
                        <StackItem>
                          <p
                            style={GrayText}
                          >{`${registeredAddress?.customerConsigneeCode}`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Tax ID (Legal Entity)</h4>
                        <StackItem >
                          <p style={GrayText}>{`${registeredAddress?.registeredtaxId}`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack></Stack>
                  </Stack>
                </Card>
              </Stack>
            )}
            {responseEditCustomer.accountId && (
              <Stack horizontal style={cardSize}>
                <Card
                  styles={{
                    layout: { height: billingAddressPixel },
                    footer: { padding: "0" },
                  }}
                  header={<CardStandardHeader cardTitle="Billing Details" />}
                  footer={
                    <Stack style={{ position: "relative" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "1px",
                          backgroundColor: "rgb(225, 223, 221)",
                          marginBottom: "10px",
                        }}
                      ></div>
                      {(genericRole !== -1 || userRole === UserRoles.GTFS) && (
                        <CardFooterBase
                          styles={{ root: { marginLeft: "12px" } }}
                          links={getLinksOfBillingAddressesDataGrid}
                        />
                      )}
                    </Stack>
                  }
                >

                  <Stack
                    verticalAlign="space-evenly"
                    tokens={{ childrenGap: 5 }}
                  >
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Billing Name</h4>
                        <StackItem
                        >
                          <p style={GrayText}>{`${primaryBillingAddress?.name ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Street (Must not be P.O. Box)
                        </h4>
                        <StackItem
                        >
                          <p style={GrayText}>{`${primaryBillingAddress?.street ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>City</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.city ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Zip/Postal Code
                        </h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.postalCode ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Purchasing Company Tax ID
                        </h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.purchasingCompanyTaxId.toLowerCase() ===
                            "n/a"
                            ? "N/A"
                            : primaryBillingAddress?.purchasingCompanyTaxId ??
                            ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Country</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.country ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>State</h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.state ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>

                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Bill To SAP Account ID
                        </h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.sapAccountId ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack style={{ marginTop: "-10px" }}>
                      <h4>Contact</h4>
                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>First Name</h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.contacts
                            ?.contactFirstName ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Last Name</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.contacts
                            ?.contactLastName ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={{ ...width33, wordBreak: 'break-word' }}>
                        <h4 style={EditContactHeadingStyle}>Phone</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.contacts?.contactPhone ??
                            ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={{ ...width33, wordBreak: 'break-word' }}>
                        <h4 style={EditContactHeadingStyle}>Email</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryBillingAddress?.contacts?.contactEmail ??
                            ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                  </Stack>

                </Card>
              </Stack>
            )}
            {responseEditCustomer.accountId && (
              <Stack horizontal style={cardSize}>
                <Card
                  styles={{
                    layout: { height: shippingAddressPixel },
                    footer: { padding: "0" },
                  }}
                  header={<CardStandardHeader cardTitle="Shipping Details" />}
                  footer={
                    <Stack style={{ position: "relative" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "1px",
                          backgroundColor: "rgb(225, 223, 221)",
                          marginBottom: "10px",
                        }}
                      ></div>
                      {(genericRole !== -1 || userRole === UserRoles.GTFS) && (
                        <CardFooterBase
                          styles={{ root: { marginLeft: "12px" } }}
                          links={getLinksOfShippingAddressesDataGrid}
                        />
                      )}
                    </Stack>
                  }
                >

                  <Stack
                    verticalAlign="space-evenly"
                    tokens={{ childrenGap: 5 }}
                  >
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Shipping Name</h4>
                        <StackItem
                        >
                          <p style={GrayText}>{`${primaryShippingAddress?.name ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Street (Must not be P.O. Box)
                        </h4>
                        <StackItem
                        >
                          <p style={GrayText}>{`${primaryShippingAddress?.street ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>City</h4>

                        <StackItem
                        >
                          <p style={GrayText}>{`${primaryShippingAddress?.city ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Zip/Postal Code
                        </h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.postalCode ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Shipment Company Tax ID
                        </h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.shipmentCompanyTaxId.toLowerCase() ===
                            "n/a"
                            ? "N/A"
                            : primaryShippingAddress?.shipmentCompanyTaxId ??
                            ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Country</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.country ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>State</h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.state ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>

                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>
                          Ship To SAP Account ID
                        </h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.sapAccountId ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack style={{ marginTop: "-10px" }}>
                      <h4>Contact</h4>
                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>First Name</h4>
                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.contacts
                            ?.contactFirstName ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={width33}>
                        <h4 style={EditContactHeadingStyle}>Last Name</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.contacts
                            ?.contactLastName ?? ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                      <Stack style={{ ...width33, wordBreak: 'break-word' }}>
                        <h4 style={EditContactHeadingStyle}>Phone</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.contacts?.contactPhone ??
                            ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 10 }}
                    >
                      <Stack style={{ ...width33, wordBreak: 'break-word' }}>
                        <h4 style={EditContactHeadingStyle}>Email</h4>

                        <StackItem>
                          <p style={GrayText}>{`${primaryShippingAddress?.contacts?.contactEmail ??
                            ""
                            }`}</p>
                        </StackItem>
                      </Stack>
                    </Stack>
                  </Stack>

                </Card>
              </Stack>
            )}
            {showAuthorizedPanel && (
              <>
                <div>
                  <CoherencePanel
                    panelSize="450px"
                    headerText="Contact/ Authorized Buyer"
                    titleText="Contact/ Authorized Buyer"
                    isOpen={isAuthorizedBuyer}
                    onDismiss={dismissNewContactAuthorizedPanel}
                    closeButtonAriaLabel="Close"
                    onRenderFooterContent={onRenderAuthorizedBuyerFooter}
                    onRenderFooter={onRenderAuthorizedBuyerFooter}
                  >
                    <div>
                      {authorizedSuccessMessage.showMessage && (
                        <MessageBar
                          messageBarType={MessageBarType.success}
                          onDismiss={() =>
                            setAuthorizedSuccessMessage(
                              InitialStateOfResponseMessage
                            )
                          }
                        >
                          {authorizedSuccessMessage.message}
                        </MessageBar>
                      )}
                      {authorizedFailureMessage.showMessage && (
                        <MessageBar
                          messageBarType={MessageBarType.error}
                          onDismiss={() =>
                            setAuthorizedFailureMessage(
                              InitialStateOfResponseMessage
                            )
                          }
                        >
                          {authorizedFailureMessage.message}
                        </MessageBar>
                      )}
                    </div>
                    <form>
                      <Stack
                        verticalAlign="space-evenly"
                        tokens={stackTokensWithGap30}
                      >
                        <Stack {...columnProps}>
                          <Stack verticalAlign="start">
                            <TextField
                              styles={RegisterCountryBoxStyles}
                              label="Job Title"
                              name="Job Title"
                              required
                              value={contactAuthorizedBuyer.contactTitle}
                              onChange={(e, contactTitleValue) => {
                                if (
                                  contactTitleValue &&
                                  contactTitleValue?.length > 0
                                ) {
                                  var specialCharacterCustomerTitleCode =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactTitleValue
                                    );
                                  if (specialCharacterCustomerTitleCode) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerTitle: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerTitle:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerTitle: "Title is Required",
                                  });
                                }
                                setContactAuthorizedBuyer({
                                  ...contactAuthorizedBuyer,
                                  contactTitle:
                                    contactTitleValue?.toString() || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  contactAuthorizedBuyer?.contactTitle &&
                                  contactAuthorizedBuyer?.contactTitle?.length >
                                  0
                                ) {
                                  var specialCharacterCustomerTitleCode =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactAuthorizedBuyer?.contactTitle
                                    );
                                  if (specialCharacterCustomerTitleCode) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerTitle: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerTitle:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerTitle: "Title is Required",
                                  });
                                }
                              }}
                              errorMessage={
                                customerEditAccountError?.authorizedBuyerTitle
                              }
                            />
                            <TextField
                              label="Contact First Name"
                              styles={MediumTextFieldStyles}
                              value={contactAuthorizedBuyer.contactFirstName}
                              required
                              onChange={(e, contactBuyerFirstNameValue) => {
                                if (
                                  contactBuyerFirstNameValue &&
                                  contactBuyerFirstNameValue?.length > 0
                                ) {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerFirstName: "",
                                  });
                                  var characterCustomerContactFirstName =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactBuyerFirstNameValue
                                    );
                                  if (characterCustomerContactFirstName) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerFirstName: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerFirstName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerFirstName:
                                      "First Name is Required",
                                  });
                                }
                                setContactAuthorizedBuyer({
                                  ...contactAuthorizedBuyer,
                                  contactFirstName:
                                    contactBuyerFirstNameValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  contactAuthorizedBuyer.contactFirstName &&
                                  contactAuthorizedBuyer.contactFirstName
                                    ?.length > 0
                                ) {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerFirstName: "",
                                  });
                                  var characterCustomerContactFirstName =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactAuthorizedBuyer.contactFirstName
                                    );
                                  if (
                                    contactAuthorizedBuyer.contactFirstName
                                      ?.length > contactNameCharacterLimit
                                  ) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerFirstName:
                                        CONTACT_FIRSTNAME_CHARACTER_LIMIT,
                                    });
                                  } else if (
                                    characterCustomerContactFirstName
                                  ) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerFirstName: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerFirstName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerFirstName:
                                      "First Name is Required",
                                  });
                                }
                              }}
                              errorMessage={
                                customerEditAccountError?.authorizedBuyerFirstName
                              }
                            />
                            <TextField
                              label="Contact Last Name"
                              styles={MediumTextFieldStyles}
                              value={contactAuthorizedBuyer.contactLastName}
                              required
                              onChange={(e, contactBuyerLastNameValue) => {
                                if (
                                  contactBuyerLastNameValue &&
                                  contactBuyerLastNameValue?.length > 0
                                ) {
                                  var characterCustomerContactFirstName =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactBuyerLastNameValue
                                    );
                                  if (characterCustomerContactFirstName) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerLastName: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerLastName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerLastName:
                                      "Last Name is Required",
                                  });
                                }

                                setContactAuthorizedBuyer({
                                  ...contactAuthorizedBuyer,
                                  contactLastName:
                                    contactBuyerLastNameValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  contactAuthorizedBuyer?.contactLastName &&
                                  contactAuthorizedBuyer?.contactLastName
                                    ?.length > 0
                                ) {
                                  var characterCustomerContactFirstName =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactAuthorizedBuyer?.contactLastName
                                    );

                                  if (
                                    contactAuthorizedBuyer?.contactLastName
                                      ?.length > contactNameCharacterLimit
                                  ) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerLastName:
                                        CONTACT_LASTNAME_CHARACTER_LIMIT,
                                    });
                                  } else if (
                                    characterCustomerContactFirstName
                                  ) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerLastName: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerLastName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerLastName:
                                      "Last Name is Required",
                                  });
                                }
                              }}
                              errorMessage={
                                customerEditAccountError?.authorizedBuyerLastName
                              }
                            />
                            <TextField
                              label="Contact Phone"
                              name="phone"
                              required
                              styles={MediumTextFieldStyles}
                              value={contactAuthorizedBuyer.contactPhone}
                              onChange={(e, contactPhoneValue) => {
                                if (
                                  contactPhoneValue &&
                                  contactPhoneValue?.length > 0
                                ) {
                                  var characterCustomerContactPhone =
                                    contactNumberRegex.test(contactPhoneValue);

                                  if (characterCustomerContactPhone) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerPhone: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerPhone:
                                        SPECIL_CHARACTER_INVALID_PHONENUMBER,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  });
                                }
                                setContactAuthorizedBuyer({
                                  ...contactAuthorizedBuyer,
                                  contactPhone: contactPhoneValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  contactAuthorizedBuyer.contactPhone &&
                                  contactAuthorizedBuyer.contactPhone?.length >
                                  0
                                ) {
                                  var checkLength = phoneNumberRegex.test(
                                    contactAuthorizedBuyer.contactPhone
                                  );
                                  var characterCustomerContactPhone =
                                    contactNumberRegex.test(
                                      contactAuthorizedBuyer.contactPhone
                                    );
                                  if (characterCustomerContactPhone) {
                                    if (!checkLength) {
                                      setEditCustomerAccountError({
                                        ...customerEditAccountError,
                                        authorizedBuyerPhone:
                                          INVALID_PHONENUMBER,
                                      });
                                    } else {
                                      setEditCustomerAccountError({
                                        ...customerEditAccountError,
                                        authorizedBuyerPhone: "",
                                      });
                                    }
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedBuyerPhone:
                                        SPECIL_CHARACTER_INVALID_PHONENUMBER,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedBuyerPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  });
                                }
                              }}
                              errorMessage={
                                customerEditAccountError?.authorizedBuyerPhone
                              }
                            />
                            <TextField
                              label="Contact Email"
                              name="email"
                              required
                              styles={MediumTextFieldStyles}
                              value={contactAuthorizedBuyer.contactEmail}
                              onChange={(e, emailValue) => {
                                if (emailValue && emailValue?.length > 0) {
                                  var customerAuthorizedEmailId =
                                    allowSpecialCharacterExcludingSome.test(
                                      emailValue
                                    );

                                  if (customerAuthorizedEmailId) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedEmailId: "",
                                    });
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedEmailId:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedEmailId:
                                      AUTHORIZED_BUYER_EMAIL_REQUIRED,
                                  });
                                }
                                setContactAuthorizedBuyer({
                                  ...contactAuthorizedBuyer,
                                  contactEmail: emailValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  contactAuthorizedBuyer.contactEmail &&
                                  contactAuthorizedBuyer.contactEmail?.length >
                                  0
                                ) {
                                  var customerAuthorizedEmailId =
                                    allowSpecialCharacterExcludingSome.test(
                                      contactAuthorizedBuyer.contactEmail
                                    );
                                  var characterCustomerAuthorizedEmailId =
                                    emailRegex.test(
                                      contactAuthorizedBuyer.contactEmail
                                    );
                                  if (
                                    contactAuthorizedBuyer.contactEmail
                                      ?.length > emailCharacterLimit
                                  ) {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedEmailId: EMAIL_CHARACTER_LIMIT,
                                    });
                                  } else if (customerAuthorizedEmailId) {
                                    if (characterCustomerAuthorizedEmailId) {
                                      setEditCustomerAccountError({
                                        ...customerEditAccountError,
                                        authorizedEmailId: "",
                                      });
                                    } else {
                                      setEditCustomerAccountError({
                                        ...customerEditAccountError,
                                        authorizedEmailId: EMAIL_VALIDATION,
                                      });
                                    }
                                  } else {
                                    setEditCustomerAccountError({
                                      ...customerEditAccountError,
                                      authorizedEmailId:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditCustomerAccountError({
                                    ...customerEditAccountError,
                                    authorizedEmailId:
                                      AUTHORIZED_BUYER_EMAIL_REQUIRED,
                                  });
                                }
                              }}
                              errorMessage={
                                customerEditAccountError?.authorizedEmailId
                              }
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </form>
                  </CoherencePanel>
                </div>
              </>
            )}
            {showRegisteredPanel && (
              <>
                <div>
                  <CoherencePanel
                    panelSize="450px"
                    headerText="Business/Sold To Address (Legal Entity)"
                    titleText="Business/Sold To Address (Legal Entity)"
                    isOpen={isRegisteredBuyer}
                    onDismiss={dismissNewRegisteredAddressPanel}
                    closeButtonAriaLabel="Close"
                    onRenderFooter={onRenderRegisteredAddressFooter}
                    onRenderFooterContent={onRenderRegisteredAddressFooter}
                  >
                    <div>
                      {registsredSuccessMessage.showMessage && (
                        <MessageBar
                          messageBarType={MessageBarType.success}
                          onDismiss={() =>
                            setRegisteredSuccessMessage(
                              InitialStateOfResponseMessage
                            )
                          }
                        >
                          {registsredSuccessMessage.message}
                        </MessageBar>
                      )}
                      {registsredFailureMessage.showMessage && (
                        <MessageBar
                          messageBarType={MessageBarType.error}
                          onDismiss={() =>
                            setRegisteredFailureMessage(
                              InitialStateOfResponseMessage
                            )
                          }
                        >
                          {registsredFailureMessage.message}
                        </MessageBar>
                      )}
                    </div>
                    <form style={editAddressPanelHeight}>
                      <Stack
                        verticalAlign="space-evenly"
                        tokens={stackTokensWithGap30}
                      >
                        <Stack {...columnProps}>
                          <Stack verticalAlign="start">
                            {" "}
                            <TextField
                              styles={
                                userRole === UserRoles.GTFS
                                  ? DisabledMediumTextFieldStyles
                                  : MediumTextFieldStyles
                              }
                              readOnly={userRole === UserRoles.GTFS}
                              label="Street (Must not be P.O. Box)"
                              name="Street Name"
                              required
                              value={registeredBuyer.registerStreet}
                              onChange={(e, streetValue) => {
                                if (streetValue && streetValue?.length > 0) {
                                  var registeredAddressStreetLength =
                                    streetValue.length;
                                  var poBoxRegexSpecialCharacterStreetPattern =
                                    allowSpecialCharacterExcludingSome.test(
                                      streetValue
                                    );
                                  if (registeredAddressStreetLength <= 60) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerStreet: "",
                                    });

                                    if (
                                      !poBoxRegexSpecialCharacterStreetPattern
                                    ) {
                                      setEditRegisterAddressError({
                                        ...editRegisterAddressError,
                                        registerStreet:
                                          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                      });
                                    } else {
                                      setEditRegisterAddressError({
                                        ...editRegisterAddressError,
                                        registerStreet: "",
                                      });
                                    }
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerStreet:
                                        "Street Length should not be greater than 60 characters",
                                    });
                                  }
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerStreet: STREET_REQUIRED,
                                  });
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerStreet: streetValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  registeredBuyer?.registerStreet &&
                                  registeredBuyer?.registerStreet?.length > 0
                                ) {
                                  var registeredAddressStreetLength =
                                    registeredBuyer?.registerStreet.length;
                                  var poBoxRegexStreetPattern = poBoxRegex.test(
                                    registeredBuyer?.registerStreet
                                  );
                                  var poBoxRegexSpecialCharacterStreetPattern =
                                    allowSpecialCharacterExcludingSome.test(
                                      registeredBuyer?.registerStreet
                                    );
                                  if (registeredAddressStreetLength <= 60) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerStreet: "",
                                    });
                                    if (
                                      poBoxRegexSpecialCharacterStreetPattern
                                    ) {
                                      if (poBoxRegexStreetPattern) {
                                        setEditRegisterAddressError({
                                          ...editRegisterAddressError,
                                          registerStreet:
                                            Street_PO_BOX_VALIDATION,
                                        });
                                      } else {
                                        setEditRegisterAddressError({
                                          ...editRegisterAddressError,
                                          registerStreet: "",
                                        });
                                      }
                                    } else {
                                      setEditRegisterAddressError({
                                        ...editRegisterAddressError,
                                        registerStreet:
                                          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                      });
                                    }
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerStreet:
                                        "Street Length should not be greater than 60 characters",
                                    });
                                  }
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerStreet: STREET_REQUIRED,
                                  });
                                }
                              }}
                              errorMessage={
                                editRegisterAddressError.registerStreet
                              }
                            />
                            <TextField
                              styles={
                                userRole === UserRoles.GTFS
                                  ? DisabledMediumTextFieldStyles
                                  : MediumTextFieldStyles
                              }
                              readOnly={userRole === UserRoles.GTFS}
                              label="Zip Code"
                              name="Zip Code"
                              required
                              value={registeredBuyer.registerPostal}
                              onChange={(e, zipValue) => {
                                if (zipValue && zipValue?.length > 0) {
                                  var specialCharacterCustomerPostalCode =
                                    allowSpecialCharacterExcludingSome.test(
                                      zipValue
                                    );
                                  if (specialCharacterCustomerPostalCode) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerPostal: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerPostal:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerPostal: POSTALCODE_REQUIRED,
                                  });
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerPostal: zipValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  registeredBuyer?.registerPostal &&
                                  registeredBuyer?.registerPostal?.length > 0
                                ) {
                                  var specialCharacterCustomerPostalCode =
                                    allowSpecialCharacterExcludingSome.test(
                                      registeredBuyer?.registerPostal
                                    );
                                  if (
                                    registeredBuyer?.registerPostal.length >
                                    postalCodeCharacterLimit
                                  ) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerPostal:
                                        POSTALCODE_CHARACTER_LIMIT,
                                    });
                                  } else if (
                                    specialCharacterCustomerPostalCode
                                  ) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerPostal: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerPostal:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerPostal: POSTALCODE_REQUIRED,
                                  });
                                }
                              }}
                              errorMessage={
                                editRegisterAddressError.registerPostal
                              }
                            />
                            <TextField
                              styles={
                                userRole === UserRoles.GTFS
                                  ? DisabledMediumTextFieldStyles
                                  : MediumTextFieldStyles
                              }
                              readOnly={userRole === UserRoles.GTFS}
                              label="City"
                              name="City"
                              required
                              value={registeredBuyer.registerCity}
                              onChange={(e, cityValue) => {
                                if (cityValue && cityValue?.length > 0) {
                                  var characterCustomerCity =
                                    allowSpecialCharacterExcludingSome.test(
                                      cityValue
                                    );
                                  if (characterCustomerCity) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCity: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCity:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerCity: CITY_REQUIRED,
                                  });
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerCity: cityValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  registeredBuyer.registerCity &&
                                  registeredBuyer.registerCity?.length > 0
                                ) {
                                  var characterCustomerCity =
                                    allowSpecialCharacterExcludingSome.test(
                                      registeredBuyer.registerCity
                                    );
                                  if (
                                    registeredBuyer.registerCity.length >
                                    cityCharacterLimit
                                  ) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCity: CITY_CHARACTER_LIMIT,
                                    });
                                  } else if (characterCustomerCity) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCity: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCity:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerCity: CITY_REQUIRED,
                                  });
                                }
                              }}
                              errorMessage={
                                editRegisterAddressError.registerCity
                              }
                            />
                            <TextField
                              styles={
                                userRole === UserRoles.GTFS
                                  ? DisabledMediumTextFieldStyles
                                  : MediumTextFieldStyles
                              }
                              readOnly={userRole === UserRoles.GTFS}
                              label="Tax ID (Legal Entity)"
                              name="Tax ID (Legal Entity)"
                              value={registeredBuyer.registerTaxId}
                              onChange={(e, registeredtaxIdValue) => {
                                if (registeredtaxIdValue?.toLocaleLowerCase() === "n/a") {
                                  registeredtaxIdValue = "N/A";
                                  setTaxIdError("");
                                  setTaxIdExist(false);
                                }
                                if (
                                  registeredtaxIdValue !== undefined &&
                                  registeredtaxIdValue !== null &&
                                  registeredtaxIdValue !== ""
                                ) {
                                  setTaxIdError("");
                                  var specialCharacterCompanyTaxId =
                                    allowSpecialCharacterExcludingSome.test(
                                      registeredtaxIdValue
                                    );
                                  if (specialCharacterCompanyTaxId) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerTaxId: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerTaxId:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    });
                                  }
                                } else {
                                  setTaxIdError("");
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerTaxId: "",
                                  });
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerTaxId: registeredtaxIdValue || "",
                                });
                              }}
                              errorMessage={
                                taxIdError !== ""
                                  ? taxIdError
                                  : ""
                              }
                            />
                            <ComboBox
                              styles={
                                userRole === UserRoles.GTFS
                                  ? DisabledRegisterCountryBoxStyles
                                  : customerEditAccountComboBoxStyle
                              }
                              disabled
                              label="Country"
                              options={regionWiseCountry}
                              required
                              selectedKey={registeredBuyer?.registerCountry}
                              onChange={(e, countryValue) => {
                                if (
                                  countryValue &&
                                  countryValue?.text.length > 0
                                ) {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerCountry: "",
                                  });
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerCountry: COUNTRY_REQUIRED,
                                  });
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerCountry:
                                    countryValue?.text.toString() || "",
                                });
                                const registerAddressPanelStateList =
                                  countryWiseStateList
                                    .filter(
                                      (x) =>
                                        x.country.toLocaleLowerCase() ===
                                        countryValue?.text.toLocaleLowerCase()
                                    )
                                    .sort((a, b) =>
                                      a.text.localeCompare(b.text)
                                    );
                                setRegisteredAddressPanelStateOptions(
                                  registerAddressPanelStateList
                                );
                              }}
                              errorMessage={
                                editRegisterAddressError.registerCountry
                              }
                            />
                            <ComboBox
                              styles={
                                userRole === UserRoles.GTFS
                                  ? DisabledRegisterCountryBoxStyles
                                  : customerEditAccountComboBoxStyle
                              }
                              disabled={userRole === UserRoles.GTFS}
                              label="State/Province"
                              options={registeredAddressPanelStateOptions}
                              required
                              selectedKey={registeredBuyer.registerState}
                              onChange={(e, stateValue) => {
                                if (
                                  stateValue &&
                                  stateValue?.text?.length > 0
                                ) {
                                } else {
                                  setEditRegisterAddressError({
                                    ...editRegisterAddressError,
                                    registerState: PROVINCE_REQUIRED,
                                  });
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerState:
                                    stateValue?.text.toString() || "",
                                });
                              }}
                              errorMessage={
                                editRegisterAddressError.registerState
                              }
                            />
                            <TextField
                              styles={MediumTextFieldStyles}
                              label="Sold To SAP Account ID"
                              name="sapAccountId"
                              value={registeredBuyer.registerSapAccountId}
                              onChange={(e, sapAccountIdValue) => {
                                if (
                                  sapAccountIdValue &&
                                  sapAccountIdValue?.length > 0
                                ) {
                                  var specialCharacterCustomersapAccountId =
                                    numbersOnly.test(sapAccountIdValue);
                                  if (specialCharacterCustomersapAccountId) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerSapAccountId: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerSapAccountId: NUMBERS_ALLOWED,
                                    });
                                  }
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerSapAccountId: sapAccountIdValue || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  registeredBuyer?.registerSapAccountId &&
                                  registeredBuyer?.registerSapAccountId
                                    ?.length > 0
                                ) {
                                  var specialCharacterCustomersapAccountId =
                                    numbersOnly.test(
                                      registeredBuyer?.registerSapAccountId
                                    );
                                  if (specialCharacterCustomersapAccountId) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerSapAccountId: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerSapAccountId: NUMBERS_ALLOWED,
                                    });
                                  }
                                }
                              }}
                              errorMessage={
                                editRegisterAddressError.registerSapAccountId
                              }
                            />
                            <TextField
                              styles={MediumTextFieldStyles}
                              label={registeredBuyer.registerCountry?.toLowerCase() === "italy" 
                                ? "Customer Certified Email*" 
                                : "Customer Certified Email"}
                              name="customerCertifiedEmail"
                              required={registeredBuyer.registerCountry?.toLowerCase() === "italy"}
                              value={
                                registeredBuyer.registerCustomerCertifiedEmail
                              }
                              onChange={(e, customerCertifiedEmail) => {
                                if (
                                  customerCertifiedEmail &&
                                  customerCertifiedEmail?.length > 0
                                ) {
                                  var characterCustomerAuthorizedEmailId =
                                    allowSpecialCharacterExcludingSome.test(
                                      customerCertifiedEmail
                                    );
                                  if (characterCustomerAuthorizedEmailId) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerCertifiedEmail: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerCertifiedEmail:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerCustomerCertifiedEmail:
                                    customerCertifiedEmail || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  registeredBuyer?.registerCustomerCertifiedEmail &&
                                  registeredBuyer
                                    ?.registerCustomerCertifiedEmail?.length > 0
                                ) {
                                  var characterCustomerAuthorizedEmailId =
                                    allowSpecialCharacterExcludingSome.test(
                                      registeredBuyer?.registerCustomerCertifiedEmail
                                    );
                                  var customerAuthorizedEmailId =
                                    emailRegex.test(
                                      registeredBuyer?.registerCustomerCertifiedEmail
                                    );
                                  if (
                                    registeredBuyer
                                      ?.registerCustomerCertifiedEmail?.length >
                                    emailCharacterLimit
                                  ) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerCertifiedEmail:
                                        EMAIL_CHARACTER_LIMIT,
                                    });
                                  } else if (
                                    characterCustomerAuthorizedEmailId
                                  ) {
                                    if (customerAuthorizedEmailId) {
                                      setEditRegisterAddressError({
                                        ...editRegisterAddressError,
                                        registerCustomerCertifiedEmail: "",
                                      });
                                    } else {
                                      setEditRegisterAddressError({
                                        ...editRegisterAddressError,
                                        registerCustomerCertifiedEmail:
                                          EMAIL_VALIDATION,
                                      });
                                    }
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerCertifiedEmail:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                }
                              }}
                              errorMessage={
                                editRegisterAddressError.registerCustomerCertifiedEmail
                              }
                            />
                            <TextField
                              styles={MediumTextFieldStyles}
                              label={registeredBuyer.registerCountry?.toLowerCase() === "italy" 
                                ? "Customer Consignee Code*" 
                                : "Customer Consignee Code"}
                              name="customerConsigneeCode"
                              required={registeredBuyer.registerCountry?.toLowerCase() === "italy"}
                              value={
                                registeredBuyer.registerCustomerConsigneeCode
                              }
                              onChange={(e, customerConsigneeCode) => {
                                if (
                                  customerConsigneeCode &&
                                  customerConsigneeCode?.length > 0
                                ) {
                                  var characterCustomerAuthorizedEmailId =
                                    allowSpecialCharacterExcludingSome.test(
                                      customerConsigneeCode
                                    );
                                  if (characterCustomerAuthorizedEmailId) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerConsigneeCode: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerConsigneeCode:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                }
                                setRegisteredBuyer({
                                  ...registeredBuyer,
                                  registerCustomerConsigneeCode:
                                    customerConsigneeCode || "",
                                });
                              }}
                              onBlur={() => {
                                if (
                                  registeredBuyer.registerCustomerConsigneeCode &&
                                  registeredBuyer.registerCustomerConsigneeCode
                                    ?.length > 0
                                ) {
                                  var characterCustomerAuthorizedEmailId =
                                    allowSpecialCharacterExcludingSome.test(
                                      registeredBuyer.registerCustomerConsigneeCode
                                    );
                                  if (characterCustomerAuthorizedEmailId) {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerConsigneeCode: "",
                                    });
                                  } else {
                                    setEditRegisterAddressError({
                                      ...editRegisterAddressError,
                                      registerCustomerConsigneeCode:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    });
                                  }
                                }
                              }}
                              errorMessage={
                                editRegisterAddressError.registerCustomerConsigneeCode
                              }
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </form>
                  </CoherencePanel>
                </div>
              </>
            )}

            {responseEditCustomer.accountId &&
              (genericRole !== -1 || userRole === UserRoles.GTFS) && (
                <Stack style={{ marginLeft: "370px" }} horizontal>
                  <PrimaryButton
                    text={userRole === UserRoles.GTFS ? "Save" : "Edit & Next"}
                    type="button"
                    disabled={isSaveAndExitButtonDisabled || !msxIdExist}
                    onClick={_OnClickNextAction}
                    style={SaveAndNextButtonStyleShipping}
                  />
                </Stack>
              )}


          </Stack>
        </>
      )}
    </Stack>
  ) : (
    <Stack></Stack>
  );
};
